/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ modifier: NonNullable<unknown> }} Pc_Zoom_In_OutInputs */

const en_pc_zoom_in_out = /** @type {(inputs: Pc_Zoom_In_OutInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zoom in / out (${i?.modifier} + scroll)`)
};

const ar_pc_zoom_in_out = /** @type {(inputs: Pc_Zoom_In_OutInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`تكبير/تصغير (${i?.modifier} + التمرير)`)
};

const bn_pc_zoom_in_out = /** @type {(inputs: Pc_Zoom_In_OutInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`জুম ইন / আউট (${i?.modifier} + স্ক্রল)`)
};

const de_pc_zoom_in_out = /** @type {(inputs: Pc_Zoom_In_OutInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vergrößern/Verkleinern (${i?.modifier} + Scrollen)`)
};

const es_pc_zoom_in_out = /** @type {(inputs: Pc_Zoom_In_OutInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Acercar/alejar (${i?.modifier} + desplazamiento)`)
};

const fr_pc_zoom_in_out = /** @type {(inputs: Pc_Zoom_In_OutInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zoom avant/arrière (${i?.modifier} + défilement)`)
};

const pt_pc_zoom_in_out = /** @type {(inputs: Pc_Zoom_In_OutInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aumentar/diminuir zoom (${i?.modifier} + rolagem)`)
};

const zh_pc_zoom_in_out = /** @type {(inputs: Pc_Zoom_In_OutInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`放大/缩小（${i?.modifier} + 滚动）`)
};

const tr_pc_zoom_in_out = /** @type {(inputs: Pc_Zoom_In_OutInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Yakınlaştır / uzaklaştır (${i?.modifier} + kaydırma)`)
};

const ru_pc_zoom_in_out = /** @type {(inputs: Pc_Zoom_In_OutInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Увеличение/уменьшение масштаба (${i?.modifier} + прокрутка)`)
};

const pl_pc_zoom_in_out = /** @type {(inputs: Pc_Zoom_In_OutInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Powiększ / pomniejsz (${i?.modifier} + przewiń)`)
};

/**
* | output |
* | --- |
* | "Zoom in / out ({modifier} + scroll)" |
*
* @param {Pc_Zoom_In_OutInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const pc_zoom_in_out = /** @type {((inputs: Pc_Zoom_In_OutInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Zoom_In_OutInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_pc_zoom_in_out(inputs)
	if (locale === "bn") return bn_pc_zoom_in_out(inputs)
	if (locale === "de") return de_pc_zoom_in_out(inputs)
	if (locale === "es") return es_pc_zoom_in_out(inputs)
	if (locale === "fr") return fr_pc_zoom_in_out(inputs)
	if (locale === "pt") return pt_pc_zoom_in_out(inputs)
	if (locale === "zh") return zh_pc_zoom_in_out(inputs)
	if (locale === "tr") return tr_pc_zoom_in_out(inputs)
	if (locale === "ru") return ru_pc_zoom_in_out(inputs)
	if (locale === "pl") return pl_pc_zoom_in_out(inputs)
	return en_pc_zoom_in_out(inputs)
});